// コレクション系ページ等で表示中の card-product インラインフォームの
// Add to cart ボタンを (在庫 - カート内数) と box 数を比較して無効化 / 有効化する。

(function () {
  const CARD_BUTTON_SELECTOR = '[data-card-box-add-to-cart]';

  function getCardButtons() {
    return document.querySelectorAll(CARD_BUTTON_SELECTOR);
  }

  function buildCartQtyMap(cart) {
    const map = {};
    (cart.items || []).forEach(function (item) {
      map[item.variant_id] = (map[item.variant_id] || 0) + item.quantity;
    });
    return map;
  }

  function applyToButton(btn, qtyMap) {
    const variantId = parseInt(btn.dataset.variantId, 10);
    const variantAvailable = btn.dataset.variantAvailable === 'true';
    const boxNum = parseInt(btn.dataset.boxNum, 10) || 1;
    const inventoryQty = parseInt(btn.dataset.inventoryQuantity, 10) || 0;
    const inventoryManagement = btn.dataset.inventoryManagement;
    const inventoryPolicy = btn.dataset.inventoryPolicy;

    // Liquid 側の disabled 判定（variant.available == false または box_soldout）と同じ式で評価する
    let boxSoldout = false;
    if (inventoryManagement === 'shopify' && inventoryPolicy !== 'continue') {
      const cartQty = qtyMap[variantId] || 0;
      const available = inventoryQty - cartQty;
      boxSoldout = available < boxNum;
    }
    const shouldDisable = !variantAvailable || boxSoldout;

    if (shouldDisable) {
      btn.setAttribute('disabled', 'disabled');
    } else {
      btn.removeAttribute('disabled');
    }
  }

  function refresh() {
    const buttons = getCardButtons();
    if (buttons.length === 0) return;

    const cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root + 'cart.js'
      : '/cart.js';

    return fetch(cartUrl, { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        const qtyMap = buildCartQtyMap(cart);
        buttons.forEach(function (btn) { applyToButton(btn, qtyMap); });
      })
      .catch(function (e) { console.error('[card-product-cart-sync] refresh failed', e); });
  }

  function init() {
    // pageshow 毎に refresh する。bfcache 採用 / HTTP キャッシュ復元の両ケースをカバーするため
    // event.persisted の条件を設けない。
    window.addEventListener('pageshow', function () {
      refresh();
    });

    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
